export default "__VITE_ASSET__BefwxnvH__"